import TemplateFrame from "../../../components/atoms/templateFrame";

function Footer() {
  return (
    <footer className="px-8 py-4">
      <TemplateFrame>
        <div className="flex flex-row justify-between items-center">
          <div className="flex items-center">
            <h2 className="text-xl font-bold mb-8">Vincent Truong</h2>
          </div>
          <div className="flex flex-row">
            <img className="h-8 w-8 mx-4" src="./static/instagram.png" alt="" />
            <img className="h-8 w-8 mx-4" src="./static/linkedin.png" alt="" />
          </div>
        </div>
      </TemplateFrame>
    </footer>
  );
}

export default Footer;
